import Dexie, { Table } from 'dexie';
import { DataPointTreeItem } from 'src/pages/SignInPage/_BLL/types';

export class MySubClassedDexie extends Dexie {
	dataPointTree!: Table<DataPointTreeItem>;

	constructor() {
		super('dataPointTree');
		this.version(1).stores({
			dataPointTree: '++key',
		});
	}
}

export const db = new MySubClassedDexie();
